import { baseUrlFrontApi } from '~/js/templates/index/helpers'
import { ID_DATA } from '~/js/constants/data-element-ids'

let APP_URL = 'francfranc-node-production.herokuapp.com'
if (globalThis.Shopify?.shop === 'ffstg.myshopify.com') {
  APP_URL = 'francfranc-node-stg.herokuapp.com'
}

const acceptNotificationUrl = `https://${APP_URL}/customer/accepts_notifications`
export const FAVORITE_TYPE = {
  product: 'product',
  hashtag: 'hashtag',
  coordinate: 'coordinate',
  article: 'article',
}
export const FAVORITE_OPERATIONS = { ADD: 'add', REMOVE: 'remove' }

export class FavouriteService {
  static addFavorite(target, targetType) {
    const params = getParams(target, targetType)
    return $.ajax({
      type: 'POST',
      url: `${baseUrlFrontApi}/favorite_item`,
      data: JSON.stringify(params),
      contentType: 'application/json',
      crossDomain: true,
    })
  }

  static removeFavorite(target, targetType) {
    const params = getParams(target, targetType)
    return $.ajax({
      type: 'POST',
      url: `${baseUrlFrontApi}/unfavorite_item`,
      data: JSON.stringify(params),
      contentType: 'application/json',
      crossDomain: true,
    })
  }

  static acceptNotification(accepts) {
    const customerId = globalThis.FFJP.userID
    return $.ajax({
      type: 'POST',
      url: acceptNotificationUrl,
      data: JSON.stringify({
        accepts: accepts,
        customer_id: customerId,
      }),
      crossDomain: true,
      dataType: 'json',
    })
  }
}

const getParams = (value, type) => {
  const element = document.getElementById(ID_DATA)
  const h = element.dataset.hashedCustomerId

  return {
    customerId: globalThis.FFJP.userID,
    h,
    target: {
      type,
      value,
    },
  }
}
